/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as r from "react";
import t from "prop-types";
import { Animation as a } from "./Animation.mjs";
const n = class n extends r.Component {
  /**
   * @hidden
   */
  render() {
    const {
      children: i,
      ...o
    } = this.props, s = {
      transitionName: "fade"
    };
    return /* @__PURE__ */ r.createElement(a, { ...s, ...o }, i);
  }
};
n.propTypes = {
  children: t.oneOfType([
    t.arrayOf(t.node),
    t.node
  ]),
  childFactory: t.any,
  className: t.string,
  component: t.string,
  id: t.string,
  style: t.any
}, n.defaultProps = {
  appear: !1,
  enter: !0,
  exit: !1,
  transitionEnterDuration: 500,
  transitionExitDuration: 500
};
let e = n;
export {
  e as Fade
};
